<section class="top-banner mb-4">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="padding: 30px 0px 0px 0px !important;"> Ajouter une entreprise</h1>
                    <p class="text-white link-nav"><a [routerLink]="['/admin']"
                            style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
                        <span> ajouter une entreprise </span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>
<br><br>

<!-- Start service Area -->
<section class="service-area section-gap" id="service">

    <div class="row  justify-content-center">
        <div class="col-lg-10">
            <fieldset class="form-area fieldset-panel min-h-340 mb-4 p-3">
                <legend class="legend-style" style="width: 50%;">Saisissez les informations de l'entreprise </legend>
                <form class=" pb-40 form-area" [formGroup]="companyForm" (ngSubmit)="onSubmitForm()">
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label for="name">Nom de l'entreprise<span class="star-style">**</span></label>
                            <input type="text" class="form-control" id="name" formControlName="name">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="areaActivity">Secteur d'activité<span class="star-style">**</span></label>
                            <select class="form-control" id="areaActivity" formControlName="area_activity_id">
                                <option value="">Selectionner...</option>
                                <option [value]="areaActivity.id" *ngFor="let areaActivity of areaActivityList">{{
                                    areaActivity.libelle
                                    }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group col-md-4">
                            <label for="acronym">Sigle<span class="star-style">**</span></label>
                            <input type="text" class="form-control" id="acronym" formControlName="acronym">
                        </div>
                        <!--                     

                        <div class="form-group col-md-4">
                            <label for="phone_1">N° téléphone 1<span class="star-style">**</span></label>
                            <input type="text" class="form-control" id="phone_1" formControlName="phone_1">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="phone_2">N° téléphone 2</label>
                            <input type="text" class="form-control" id="phone_2" formControlName="phone_2">
                        </div> -->

                        <div class="form-group col-md-4">
                            <label for="country_company">Pays<span class="star-style">**</span></label>
                            <select type="text" class="form-control" id="country_company" formControlName="country">
                                (ngModelChange)="onChangeCountry($event)">
                                <option value="">Selectionner...</option>
                                <option [value]="country" *ngFor="let country of countryList">{{ country }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="city_company">Ville<span class="star-style">**</span></label>
                            <select type="text" class="form-control" id="city_company" formControlName="city">
                                <option value="">Selectionner...</option>
                                <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                            </select>
                        </div>

                        <div class="form-group col-md-4">
                            <label for="address_company">Adresse<span class="star-style">**</span></label>
                            <input type="text" class="form-control" id="address_company" formControlName="address">
                        </div>
                        <!-- <div class="form-group col-md-4">
                            <label for="nb_person">Nombre d'employés<span class="star-style">**</span></label>
                            <select class="form-control" id="nb_person" formControlName="nb_person">
                                <option value="">Selectionner...</option>
                                <option value="1 à 5">1 à 5</option>
                                <option value="6 à 10">6 à 10</option>
                                <option value="10 à 50">10 à 50</option>
                                <option value="50 à 100">50 à 100</option>
                                <option value="Plus de 100">Plus de 100</option>
                            </select>
                        </div> -->

                        <!-- <div class="form-group col-md-4">
                            <label for="email">Email</label>
                            <input type="email" class="form-control" id="email" value="{{companies.getEmail()}}">
                        </div> -->
                        <div class="form-group col-md-4">
                            <label for="curriculumVitae">Logo <span style="font-size: 10px; font-weight: 700;">(PNG,
                                    JPEG < 1Mo)</span>
                                        <span class="star-style">**</span></label>
                            <span class="btn btn-success w-100" (click)="chooseLogo()">Joindre
                                Logo</span>

                            <span *ngIf="logoFile != null" style="font-size: 10px; font-weight: 700; color: green">
                                Super! Fichier
                                joint</span>
                        </div>
                        <div class="form-group col-md-2 my-auto pt-3">
                            <a [href]="logoPath" target="_blank" class="btn btn-info w-100"
                                *ngIf="logoPath != null">Afficher Logo</a>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                        <label for="description">Description</label>
                        <textarea class="form-control" id="description" formControlName="description"
                            row="4"></textarea>
                    </div> -->
                    <div class="row justify-content-center">
                        <button type="submit" class="primary-btn text-white mb-4" [disabled]="companyForm.invalid"
                            *ngIf="!isLoading">Enregister</button>
                        <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">Veuillez
                            patienter...
                        </p>
                    </div>
                </form>
            </fieldset>
        </div>
    </div>


</section>
<!-- End service Area -->